function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "F6ACA663-D967-436E-B225-24C0302D1D37");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Wireframe-Gestionnaire-",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Gestionnaire_Liste_Dossiers_Tous_Desktop-Copy",
  transform: "translate(-25.000000, -178.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons/credit-card",
  transform: "translate(25.000000, 178.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.125,1.875 C14.1605339,1.875 15,2.71446609 15,3.75 L15,11.25 C15,12.2855339 14.1605339,13.125 13.125,13.125 L1.875,13.125 C0.839466094,13.125 0,12.2855339 0,11.25 L0,3.75 C0,2.71446609 0.839466094,1.875 1.875,1.875 L13.125,1.875 Z M13.75,6.874 L1.25,6.874 L1.25,11.25 C1.25,11.595178 1.52982203,11.875 1.875,11.875 L13.125,11.875 C13.470178,11.875 13.75,11.595178 13.75,11.25 L13.75,6.874 Z M13.125,3.125 L1.875,3.125 C1.52982203,3.125 1.25,3.40482203 1.25,3.75 L1.25,5.624 L13.75,5.624 L13.75,3.75 C13.75,3.40482203 13.470178,3.125 13.125,3.125 Z",
  id: "Combined-Shape"
}))));

var SvgCreditCard = function SvgCreditCard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCreditCard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/credit-card.8b38cd15.svg";
export { ForwardRef as ReactComponent };